import { Link } from "react-router-dom";
import { useBreadcrumb } from "@/contexts/BreadcrumbContext";
import { useEffect } from "react";

export function Admin() {
  const { setBreadcrumbs, clearBreadcrumbs } = useBreadcrumb();

  useEffect(() => {
    setBreadcrumbs([
      { label: "Admin", path: "/admin" },
    ]);

    return () => {
      clearBreadcrumbs();
    };
  }, []);

  return (
    <div className="p-4">
      <div className="space-y-2">
        <Link
          to="/admin/artists"
          className="block p-4 border rounded-md hover:bg-accent transition-colors"
        >
          Artists
        </Link>
        <Link
          to="/admin/users"
          className="block p-4 border rounded-md hover:bg-accent transition-colors"
        >
          Users
        </Link>
      </div>
    </div>
  );
}

